import { useQuery } from 'react-query';
import { useSelector } from 'react-redux';
import { authFetch } from '../../CommonUtils/authFetch';
import { urlWithParams } from '../../CommonUtils/urlWithParams';
import { data as selectLegacyFinancialPlanData } from '../../FinancialPlan/FinancialPlanSelector';
import { useClientId } from '../../_hooks/useClientId';
import { useFpId } from '../hooks/useFpId';
import { useIsPdf } from '../hooks/useIsPdf';
import { FinancialPlanDTO } from '../types/financialPlan.types';
import { queryKeys } from './queryKeys';

interface FetchGoalsParams {
  clientId: number;
  fpId: string | null;
  isPdf: boolean;
}

const fetchFinancialPlanWhatIfs = async ({
  clientId,
  fpId,
  isPdf,
}: FetchGoalsParams): Promise<FinancialPlanDTO> => {
  return authFetch(
    urlWithParams('/Consumer/FinancialPlanWhatIfs', {
      clientId,
      fpId,
      IsPdf: isPdf,
    }),
  );
};

export const useFinancialPlanQuery = () => {
  const legacyFinancialPlanData: FinancialPlanDTO = useSelector(selectLegacyFinancialPlanData);

  const clientId = useClientId();

  const fpId = useFpId();

  const isPdf = useIsPdf();

  return useQuery(
    queryKeys.financialPlan(clientId, fpId, isPdf),

    () => (isPdf ? legacyFinancialPlanData : fetchFinancialPlanWhatIfs({ clientId, fpId, isPdf })),

    {
      enabled: !!fpId,
      /**
       * This arbitrarily small cacheTime is needed to prevent AB#187718.
       *
       * Currently, when switching between different goal types,
       * there is a remount of this query. Without a small cacheTime,
       * the query is refetched, which causes the bug.
       *
       * This should no longer be needed after completing the OPL migration
       * of all the goals.
       */
      cacheTime: 1_000,
    },
  );
};
